import { computed } from 'vue';
import useTraits from '@nuxt-common/media-card-large/app/composables/useTraits';
import useAvailability from '@nuxt-common/media-card-large/app/composables/useAvailability';
import { usePageData } from '~/composables/usePageData';

export default function useSelectedTraitUnavailable() {
  const { productId } = usePageData();
  const { size, color } = useAvailability(productId);
  const { selectedSize, selectedColor } = useTraits(productId);
  const isSelectedTraitUnavailable = computed(
    () => !!(selectedColor.value && !color.value?.[selectedColor.value.id]) || !!(selectedSize.value && !size.value?.[selectedSize.value.id]),
  );

  return { isSelectedTraitUnavailable };
}
